'use strict';

export function UserResource($resource) {
  'ngInject';

  return $resource('/api/users/:id/:controller', {
    id: '@id'
  }, {
    //----------------GET----------------
    get: {
      method: 'GET',
      params: {
        id: 'me'
      }
    },
    logout: {
      method: 'GET',
      params: {
        id: 'logout'
      }
    },
    //----------------PUT----------------
    changePassword: {
      method: 'PUT',
      params: {
        controller: 'password'
      }
    },
    updateInfo: {
      method: 'PUT',
      params: {
        controller: 'me'
      }
    },
  });
}



// WEBPACK FOOTER //
// ./client/components/auth/user.service.js